import { render } from "./CustomTagsInput.vue?vue&type=template&id=43de85a6&scoped=true"
import script from "./CustomTagsInput.vue?vue&type=script&lang=js"
export * from "./CustomTagsInput.vue?vue&type=script&lang=js"

import "./CustomTagsInput.vue?vue&type=style&index=0&id=43de85a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43de85a6"]])

export default __exports__